export const NEW_NAVBAR = "newNavbar";
export const USER_AUTHENTICATE_SUCCESS = "USER_AUTHENTICATE_SUCCESS";
export const TRAVEL_REQUEST_ID = "TRAVEL_REQUEST_ID";
export const USER_LOGOUT = "USER_LOGOUT";
